import {PRODUCTION} from "@irati/utils/constants/environment"
import env from "@irati/utils/env"
import {initializePhraseAppEditor} from "react-intl-phraseapp"
import {IntlOverrides} from "@irati/utils/lang/Provider"
import {IntlCtx} from "@irati/utils/lang/types"

const canUsePhrase = env.ENVIRONMENT_NAME !== PRODUCTION

const config = {
  phraseEnabled: true,
  // our public project id
  projectId: "44025e52a4c94e44efe99762f0e1dbdd",
  // used to duplicate keys
  prefix: "[[__",
  suffix: "__]]",
  // we use camel-case keys
  autoLowercase: false,
  fullReparse: true
}

type FormatMessage = IntlCtx["formatMessage"]

/**
 * expose a function `enablePhraseEditor` to the window object, i.e this can be
 * invoked from `window.enablePhraseEditor()` from the browser console
 *
 * @see [phrase](https://support.phrase.com/hc/en-us/articles/5784095916188-In-Context-Editor-Strings)
 */
export function setupPhraseWindowFn() {
  if (canUsePhrase) {
    window.enablePhraseEditor = () => {
      initializePhraseAppEditor(config)
    }
  }
}

export const intlOverrides: IntlOverrides = (intl) => {
  return {
    formatMessage: formatMessageFactory(intl.formatMessage)
  }
}

export function formatMessageFactory(original: FormatMessage): FormatMessage {
  if (!canUsePhrase) return original

  return (desc, values) => {
    if (window.PHRASEAPP_ENABLED) {
      if (!desc.id || typeof desc.id !== "string") throw new Error("no id of type string was passed to `formatMessage`")

      const escapedString = desc.id.replace("<", "[[[[[[html_open]]]]]]").replace(">", "[[[[[[html_close]]]]]]")

      return `${config.prefix}phrase_${escapedString}${config.suffix}` as any
    }

    return original(desc, values)
  }
}

declare global {
  interface Window {
    PHRASEAPP_ENABLED: boolean
    PHRASEAPP_CONFIG: any
    enablePhraseEditor?: () => void
  }
}
